import { ListTree } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ListTreeIcon = createLucideIcon(ListTree);
